const CURRENT_USER_OBJECT = localStorage.getItem("currentUser")
  ? JSON.parse(localStorage.getItem("currentUser"))
  : "";
const VATPERCENTAGE = CURRENT_USER_OBJECT[0]?.vatp;

export const defaultColumnsOrder = [
  "Slno",
  "Code",
  "Description",
  "Locn",
  "Unit",
  "Qty",
  "Unit Cost",
  "Amount",
  "Frac",
  "VAT",
  "Vat%",
  "Vatamt",
  "Total",
  "OEM",
  "MastInfo",
  "Disc%",
  "Remarks",
  "Tr Doc",
  "Doc No.",
];

// 2. Field Mapping (Header Name to Internal State Key)
export const columnFieldMap = {
  Slno: "sino",
  Code: "code",
  Description: "description",
  Locn: "location",
  Unit: "unit",
  Qty: "qty",
  "Unit Cost": "unitCost",
  Amount: "amount",
  Frac: "fraction",
  VAT: "vatEnabled",
  "Vat%": "vatPercent",
  Vatamt: "vatAmount",
  Total: "total",
  OEM: "oem",
  MastInfo: "mastInfo",
  "Disc%": "Discount%",
  Remarks: "remarks",
  "Tr Doc": "trDoc", // New field
  "Doc No.": "docNo", // New field
  // Removed: "Unit BCCost", "Oth.Cost", "x", "cntrl", "Pono", "Group", "GIT", "Salesperson", "Bin", "DCP"
};

// 3. Base Column Configuration Function
export const getBaseColumn = (
  field,
  widthMap,
  renderers,
  locationOptions,
  unitOptions,
  salespersonOptions // Kept for consistency, though Salesperson is removed from Order
) => {
  const baseConfig = {
    field,
    headerName:
      Object.entries(columnFieldMap).find(
        ([, value]) => value === field
      )?.[0] || field,
    width: widthMap?.[field] || 100,
    sortable: false,
    filterable: false,
    disableColumnMenu: false,
  };

  if (field === "vatEnabled") {
    return {
      ...baseConfig,
      headerName: "VAT",
      width: widthMap?.[field] || 60,
      renderCell: (params) => renderers.renderVatToggle(params, field),
    };
  }

  // Numeric fields for PO
  if (
    [
      "qty",
      "unitCost",
      "amount",
      "fraction",
      "vatPercent",
      "vatAmount",
      "total",
      "Discount%",
    ].includes(field)
  ) {
    return {
      ...baseConfig,
      renderCell: (params) =>
        renderers.renderEditableCell(params, field, "number"),
    };
  }

  // Text fields for PO
  if (
    [
      "code",
      "description",
      "mastInfo",
      "oem",
      "remarks",
      "trDoc", // New field
      "docNo", // New field
    ].includes(field)
  ) {
    return {
      ...baseConfig,
      renderCell: (params) => renderers.renderEditableCell(params, field),
    };
  }

  if (field === "location") {
    return {
      ...baseConfig,
      renderCell: (params) =>
        renderers.renderSelectCell(params, "location", locationOptions),
    };
  }

  if (field === "unit") {
    return {
      ...baseConfig,
      renderCell: (params) =>
        renderers.renderSelectCell(params, "unit", unitOptions),
    };
  }

  // Note: Salesperson select cell is not returned as it's not in defaultColumnsOrder

  return baseConfig;
};

export const calculateRowValues = (item, purchaseData) => {
  const qty = Number(item.qty) || 0;
  const unitCost = Number(item.unitCost) || 0;
  const discountPercent = Number(item["Discount%"]) || 0;

  const documentVatPercent =
    purchaseData?.vatStatus === "VAT Applied" ? VATPERCENTAGE : 0;

  const lineVatEnabled = item.vatEnabled !== false;
  const vatPercent = lineVatEnabled ? documentVatPercent : 0;

  const grossLineAmountBeforeDiscount = qty * unitCost;

  const discountAmount =
    grossLineAmountBeforeDiscount * (discountPercent / 100);

  const amount = grossLineAmountBeforeDiscount - discountAmount;

  const vatAmount = (amount * vatPercent) / 100;

  const calculatedTotal = amount + vatAmount;

  return {
    ...item,
    // othCost is removed, or kept as 0 if the field must exist in the state
    amount: amount.toFixed(2),
    vatPercent,
    vatAmount: vatAmount.toFixed(2),
    total: calculatedTotal.toFixed(2),
  };
};

export const getVatPercent = (purchaseData) => {
  return purchaseData?.vatStatus === "VAT Applied" ? VATPERCENTAGE : 0;
};

export const requiredFields = [
  "code",
  "description",
  "location",
  "unit",
  "qty",
  "unitCost",
];

export const newItemTemplate = (id, sino, defaultLocation) => ({
  id,
  sino,
  code: "",
  description: "",
  location: defaultLocation,
  unit: "",
  qty: 0,
  unitCost: 0,
  amount: 0,
  fraction: 0,
  vatEnabled: true,
  vatPercent: VATPERCENTAGE,
  vatAmount: 0,
  total: 0,
  "Discount%": 0,
  remarks: "",
  trDoc: "",
  docNo: "",
  isIncluded: true,
});

export const defaultColumnPercents = {
  sino: 5,
  code: 10,
  description: 25,
  location: 10,
  unit: 8,
  qty: 8,
  unitCost: 10,
  amount: 10,
  vatEnabled: 5,
  vatPercent: 8,
  vatAmount: 8,
  total: 10,
  "Discount%": 8,
};

const screenCode = "PURCHASE_ORDER";

export const purchaseOrderConfig = {
  columnFieldMap,
  defaultColumnsOrder,
  getBaseColumn,
  calculateRowValues,
  getVatPercent,
  screenCode,
  defaultColumnPercents,
  requiredFields,
  newItemTemplate,
};

export default purchaseOrderConfig;